import { combineReducers, configureStore } from '@reduxjs/toolkit';
import productsReducer from './slices/productsSlice';
import cartReducer from './slices/cartSlice';
import authReducer from './slices/authSlice';
import ordersReducer from './slices/ordersSlice';
import quotesReducer from './slices/quotesSlice';
import designReducer from './slices/designSlice';
import reviewsReducer from './slices/reviewsSlice';
import wishlistReducer from './slices/wishlistSlice';
import loyaltyReducer from './slices/loyaltySlice';

const rootReducer = combineReducers({
  products: productsReducer,
  cart: cartReducer,
  auth: authReducer,
  orders: ordersReducer,
  quotes: quotesReducer,
  design: designReducer,
  reviews: reviewsReducer,
  wishlist: wishlistReducer,
  loyalty: loyaltyReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

// Gyár: a tesztek minden esethez friss store-t kérnek (opcionális kezdőállapottal).
export const makeStore = (preloadedState?: Partial<RootState>) =>
  configureStore({ reducer: rootReducer, preloadedState });

export const store = makeStore();

export type AppDispatch = typeof store.dispatch;
